module.exports = __webpack_public_path__ + "img/vip.0349794f.svg";